import {FETCH_SPORTS, SELECTED_SPORTS , FILTER_CATEGORY , FILTER_SAVED_SPORTS , FILTER_SAVED_CATEGORY  , CHECKBOX_COUNT } from "../action/actionConstants";

export default function location(state = {allSports : [],
                                          sportsSelected : [],
                                          filterCategory : [],
                                          filterSavedSports : [],
                                          filterSavedCategory : [],
                                          checkBoxCount : 0
                                          }, action) {

  switch (action.type) {

    case FETCH_SPORTS: {
      return {...state,
       allSports: action.payload
     }
   }
     case SELECTED_SPORTS : {
       return {...state,
        sportsSelected: action.payload
      }
    }

    case FILTER_CATEGORY : {
      return {...state,
       filterCategory: action.payload
     }
   }

  case FILTER_SAVED_SPORTS : {
    return {...state,
      filterSavedSports: action.payload
   }
  }

  case FILTER_SAVED_CATEGORY : {
    return {...state,
      filterSavedCategory: action.payload
   }
  }

  case CHECKBOX_COUNT :{
    return {...state,
      checkBoxCount: action.payload
   }
  }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/sportsFilter.js